<template>
  <v-form action="javascript:void(0);" method="post" ref="form" id="contact-form">
    <v-container class="pa-0">
      <v-layout wrap>
        <p>{{$tf('Idonia is a certified and secure service that allows the exchange of medical tests and images through the Internet')}}</p>
        <p>{{$tf('If you want us to help you get any test done in a medical center, give us the data and we will help you get it:')}}</p>
        <v-flex xs12 mt-2><h3 style="font-weight: normal">{{$tf('Your Info')}}</h3></v-flex>
        <v-flex xs12 sm6 md4>
          <v-text-field
              name="firstname"
              :label="$tf('Firstname')"
              required
              v-model="fields.firstname.value"
              :rules="fields.firstname.rules"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <v-text-field
              name="lastname"
              :label="$tf('Lastname')"
              required
              v-model="fields.lastname.value"
              :rules="fields.lastname.rules"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6>
          <v-text-field
              name="email"
              label="Email"
              required
              v-model="fields.email.value"
              id="email"
              :rules="fields.email.rules"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-flex xs12 mt-4><h3 style="font-weight: normal">{{$tf('Facility Info')}}</h3></v-flex>
      <v-layout wrap>
        <v-flex xs12 sm6 >
          <v-text-field
              name="center-name"
              :label="$tf('Medical Center')"
              v-model="fields.centerName.value"
              :rules="fields.centerName.rules"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 >
          <v-text-field
              name="center-email"
              :label="$tf('Center email')"
              v-model="fields.centerEmail.value"
              :rules="fields.centerEmail.rules"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6>
          <v-text-field
              name="center-telefon"
              :label="$tf('Center phone')"
              v-model="fields.centerPhone.value"
              :rules="fields.centerPhone.rules"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
              id="message"
              name="message"
              :label="$tf('Your message')"
              required
              v-model="fields.message.value"
              multi-line
              :placeholder="$tf('Medical request placeholder')"
              :rules="fields.message.rules"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import useInPlaceValidation from '~/commons/validation'
import { ref } from '@vue/composition-api'

export default {
  name: 'medical-results-form',
  props: {
    submit: {
      type: Boolean,
      default: false
    },
    reset: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    account: {
      type: Object,
      default: () => ({})
    }
  },
  setup (props) {
    const { fields, setValidationCallback } = useInPlaceValidation({
      firstname: {
        name: 'Firstname',
        rules: ['required', 'maxLength:100'],
        value: ref(props.account.firstname)
      },
      lastname: {
        name: 'Lastname',
        rules: ['required', 'maxLength:100'],
        value: ref(props.account.lastname)
      },
      email: {
        name: 'Email',
        rules: ['required', 'email'],
        value: ref(props.account.email)
      },
      centerName: {
        name: 'Medical Center',
        rules: ['maxLength:100'],
        value: ref('')
      },
      centerEmail: {
        name: 'Center email',
        rules: ['email'],
        value: ref('')
      },
      centerPhone: {
        name: 'Center phone',
        rules: ['regex:^\\+?[0-9]*$:validation.default', 'minLength:7'],
        value: ref('')
      },
      message: {
        name: 'Your message',
        rules: ['required'],
        value: ref('')
      }
    })
    return {
      fields,
      setValidationCallback
    }
  },
  mounted () {
    this.setValidationCallback(this.setValid)
  },
  methods: {
    setValid (valid) {
      this.$store.dispatch('dialog/setValid', valid)
    },
    cancel () {},
    accept () {
      if (!this.$refs.form.validate()) {
        this.$store.dispatch('dialog/setValid', false)
        throw new Error('Form is not valid')
      }
      this.$store.dispatch('dialog/setValid', true)
      return this.$http.post('https://us-central1-idonia-public.cloudfunctions.net/idonia-ui-troubleshoot-function-sendmail', {
        'name': this.fields.firstname.value + ' ' + this.fields.lastname.value,
        'email': this.fields.email.value,
        'message': 'Center Name: ' + this.fields.centerName.value +
          '\nCenter email: ' + this.fields.centerEmail.value +
          '\nCenter phone: ' + this.fields.centerPhone.value +
          '\n Message: ' + this.fields.message.value
      }).then(() => {
        this.$store.dispatch('feedback/addSnack', {
          text: this.$tf(`Thank you, your request has been sent.`),
          type: 'info',
          timeout: 2000
        })
      })
    }
  }
}
</script>

<style>
  #contact-form .input-group--required label:after {
    padding-left: 5px;
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/dialog/types/DialogGetMedicalResults.vue